import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { NotificationManager } from "react-notifications";
import Paginacion from "../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import moment from "moment";
import { FiltrosReporte } from "../components/FiltosReporte";
import { GraficaTraslados } from "../components/GraficaTraslados";
import { ReporteMensualApi } from "./api/ReporteMensualApi";
import { ListadoMensualTable } from "./components/ListadoMensualTable";
import {
    dateToDayStart,
    dateToDayEnd,
    getErrorFromResponse,
} from "../../../../../../../utility/utils";

export const ReporteMensual = ({ storageKey }) => {
    const STORAGE_KEY = storageKey;
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const [fechaInicial, setFechaInicial] = useState(
        filtros.fecha_inicial ? moment(filtros.fecha_inicial) : null,
    );
    const [fechaFinal, setFechaFinal] = useState(
        filtros.fecha_final ? moment(filtros.fecha_final) : null,
    );

    const [trasladosMensual, setTrasladosMensual] = useState([]);
    const [trasladosGrafica, setTrasladosGrafica] = useState([]);
    const [totalesTraslados, setTotalesTraslados] = useState({});

    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const { getTrasladosReporteMensual, cargando, obtenerReporteMensualExcel } =
        ReporteMensualApi();

    const construirParams = (page) => {
        const params = {};

        if (page) {
            params.page = page;
        }

        params.fecha_inicial = dateToDayStart(fechaInicial);
        params.fecha_final = dateToDayEnd(fechaFinal);

        return params;
    };

    const GetTrasladosReporteMensual = async () => {
        if (!fechaInicial || !fechaFinal) {
            setTrasladosMensual([]);
            setCantidadResultados(0);
            setTotalesTraslados({});
            return;
        }

        try {
            const response = await getTrasladosReporteMensual(
                construirParams(paginaSeleccionada),
            );
            setTrasladosMensual(response.results);
            setCantidadResultados(response.count);
            setTotalesTraslados(response.totales);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener reporte mensual de traslados",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            console.error("Error al obtener reporte mensual de traslados:", error);
            setTrasladosMensual([]);
            setCantidadResultados(0);
            setTotalesTraslados({});
        }
    };

    const GetTrasladosGrafica = async () => {
        if (!fechaInicial || !fechaFinal) {
            setTrasladosGrafica([]);
            return;
        }

        try {
            const params = construirParams();
            params.modo = "grafica";

            const response = await getTrasladosReporteMensual(params);
            setTrasladosGrafica(response.results);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener reporte mensual de traslados",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            console.error("Error al obtener reporte mensual de traslados:", error);
            setTrasladosGrafica([]);
        }
    };

    const FiltrarReporte = () => {
        if (!fechaInicial || !fechaFinal) {
            NotificationManager.warning(
                "Por favor, selecciona una fecha inicial y una fecha final para filtrar el reporte.",
                "Fechas incompletas",
                3000,
            );
            return;
        }

        if (paginaSeleccionada !== 1) {
            setPaginaSeleccionada(1);
        } else {
            GetTrasladosReporteMensual();
        }

        GetTrasladosGrafica();
    };

    useEffect(() => {
        GetTrasladosReporteMensual();
    }, [paginaSeleccionada]);

    // si se restauraron fechas guardadas en sessionStorage, cargar la gráfica también
    useEffect(() => {
        GetTrasladosGrafica();
    }, []);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                fecha_inicial: fechaInicial,
                fecha_final: fechaFinal,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [fechaInicial, fechaFinal, paginaSeleccionada]);

    const ObtenerReporteMensualExcel = async () => {
        if (!fechaInicial || !fechaFinal) {
            NotificationManager.warning(
                "Por favor, selecciona una fecha inicial y una fecha final para filtrar el reporte.",
                "Fechas incompletas",
                3000,
            );
            return;
        }

        try {
            await obtenerReporteMensualExcel(construirParams());
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el reporte mensual en Excel",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    return (
        <div className="listado-traslados__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <div className="reporte-traslados__table-header">
                        <FiltrosReporte
                            fechaInicial={fechaInicial}
                            setFechaInicial={setFechaInicial}
                            fechaFinal={fechaFinal}
                            setFechaFinal={setFechaFinal}
                            onFiltrar={FiltrarReporte}
                        />
                        <div className="ml-auto formulario-fields-row flex-nowrap">
                            <div className="formulario-field">
                                <button
                                    className="btn btn-primary mt-auto text-nowrap"
                                    onClick={ObtenerReporteMensualExcel}
                                    disabled={!trasladosMensual.length}
                                >
                                    Exportar Excel
                                </button>
                            </div>
                        </div>
                    </div>

                    {trasladosMensual.length > 0 && (
                        <GraficaTraslados
                            traslados={trasladosGrafica}
                            campoEje="mes"
                            mostrarVariacionProduccion
                        />
                    )}

                    <ListadoMensualTable
                        traslados={trasladosMensual}
                        totalesTraslados={totalesTraslados}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
